import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconLitologySizeS from './IconLitology_size_s';

const props: CreateIconArguments = {
  l: IconLitologySizeS,
  m: IconLitologySizeS,
  s: IconLitologySizeS,
  xs: IconLitologySizeS,
  name: 'IconLitology',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
